exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-primary2[data-v-0df6ac38]{color:#004085;background-color:#cce5ff;border-color:#b8daff}.alert-success2[data-v-0df6ac38]{color:#155724;background-color:#d4edda;border-color:#c3e6cb}", ""]);

// exports
